import {LabelWithoutJson} from '@/components/atoms'
import {PageContainer} from '@/components/organisms'
import {COLOR_CODE} from '@/utils/constants/colors'
import {FONT_WEIGHT} from '@/utils/constants/globalStyle'

const TaxAndSales = ({productData}) => {
  const LabelWithVal = ({keyName, val}) => {
    const id = keyName?.toLowerCase()?.replaceAll(' ', '_') ?? ''
    return (
      <div className="col-4 pt-5">
        <div className="">
          <LabelWithoutJson id={`${id}_label`} text={keyName} />
        </div>
        <div className="w-49">
          <LabelWithoutJson
            id={`${id}_value`}
            text={val}
            isValueDiasbledInput={false}
            fontWeight={FONT_WEIGHT.BOLD}
            color={COLOR_CODE._FFFFFF}
          />
        </div>
      </div>
    )
  }

  return (
    <PageContainer>
      <div className="productoverview-brand-category">
        {/* Tax Detail */}
        <div className="sc-border heading mt-[29px] pb-5 text-base font-bold">Taxes</div>

        {productData?.taxes?.map((item, index) => {
          return (
            <div key={`${index}`} className="grid grid-cols-3 gap-4 pb-5">
              <LabelWithVal keyName="Tax Type Code" val={item?.taxTypeCode || '-'} />
              <LabelWithVal keyName="Tax Country Code" val={item?.taxCountryCode || '-'} />
              <LabelWithVal keyName="Tax Code" val={item?.taxCode || '-'} />
              <LabelWithVal keyName="Tax Name" val={item?.taxName || '-'} />
            </div>
          )
        })}

        {/* Sale Uoms */}
        <div className="sc-border heading mt-[29px] pb-5 text-base font-bold">Sale UoMs</div>
        {productData?.saleUoms?.map((item, index) => {
          return (
            <div key={`${index}`}>
              <div className="mt-[29px] text-base font-semibold">
                {'Sale UoMs '}
                {index + 1}
              </div>
              <div className="grid grid-cols-3 gap-4 pb-5">
                <LabelWithVal
                  keyName="Code"
                  val={
                    item?.code && item?.name
                      ? `${item.code} (${item.name})`
                      : item?.code
                        ? `${item.code} (-)`
                        : item?.name
                          ? `- (${item.name})`
                          : '-'
                  }
                />
                <LabelWithVal keyName="UPC" val={item?.upc || '-'} />
                <LabelWithVal keyName="Base Uom Conversion Numerator" val={item?.baseUomConversionNumerator || '-'} />
                <LabelWithVal
                  keyName="Base Uom Conversion Denominator"
                  val={item?.baseUomConversionDenominator || '-'}
                />
              </div>
            </div>
          )
        })}
      </div>
    </PageContainer>
  )
}

export default TaxAndSales
